import { useParams } from 'react-router';
import { useEffect } from 'react';

import { getUserId, trackGtmEvent } from '@/helpers';
import { UseTrackEvent } from './types';

const useTrackEvent: UseTrackEvent = (event) => {
  const { type, id } = useParams<{ type: string; id: string }>();

  useEffect(() => {
    if (!type || !id || !event) {
      return;
    }
    trackGtmEvent('modal_view', {
      event_category: 'EventView',
      event_action: 'view',
      user_id: getUserId(),
      vendor_id: event.vendor.id,
      popup_event_vendor_id: id,
      event_type: type?.split('_')[1] || '',
      product: event.productType,
      confirmation_status: 'confirmed' in event ? event.confirmed : undefined,
    });
  }, [type, id, event]);
};

export default useTrackEvent;
